import { ROLES } from '../actionTypes';

const initialState = {
  content: [],
  internalRoles: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ROLES.SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    case ROLES.INTERNAL_SUCCESS:
      return {
        ...state,
        internalRoles: action.payload,
      };
    default:
      return state;
  }
};
